export default () => [
	{
		name: "Pagina Inicial",
		route: "/master-page",
		icon: "house",
		authorities: ["ROLE_BENEFICIARIO_UPLOADER", "ROLE_CLIENTE"],
	},
	{
		name: "Beneficiários",
		route: "/master-page/historico-beneficiario",
		icon: "person",
		authorities: ["ROLE_ADMIN", "ROLE_CONSULTOR_RELACIONAMENTO", "ROLE_CLIENTE"],
	},
	{
		name: "Importar Beneficiários",
		route: "/master-page/importar-beneficiarios",
		icon: "importar-beneficiarios",
		authorities: ["ROLE_BENEFICIARIO_UPLOADER"],
	},
	{
		name: "Histórico de carga",
		route: "/master-page/historico-importacao",
		icon: "clock",
		authorities: ["ROLE_ADMIN", "ROLE_CONSULTOR_RELACIONAMENTO", "ROLE_CLIENTE"],
	},
	{
		name: "Administração",
		route: "/master-page",
		icon: "desktop",
		sublinks: [
			// {
			// 	name: "Perfis",
			// 	route: "/master-page/listar-perfis",
			// 	authorities: ["ROLE_ADMIN", "ROLE_CRUD_PROFILE"],
			// },
			{
				name: "Usuários",
				route: "/master-page/listar-usuarios",
				authorities: ["ROLE_ADMIN", "ROLE_CONSULTOR_RELACIONAMENTO", "ROLE_CRUD_USER"],
			},
			{
				name: "Corrigir Erros Inesperados",
				route: "/master-page/corrigir-erros-inesperados",
				authorities: ["ROLE_ADMIN", "ROLE_CRUD_PROFILE"],
			},
			{
				name: "Configurações",
				route: "/master-page/configuracoes", 
				authorities: ["ROLE_ADMIN", "ROLE_CRUD_PROFILE"],
			},
		],
	},
	{
		name: "Histórico de inativação",
		route: "/master-page/historico-inativacao",
		icon: "historico",
		authorities: ["ROLE_ADMIN"],
	},
	{
		name: "Relatório de Utilização" ,
		route: "/master-page/relatorio",
		icon: "line-chart",
		authorities: ["ROLE_ADMIN", "ROLE_CONSULTOR_RELACIONAMENTO", "ROLE_UTILIZACAO_MENSAL"],
	},
	{
		name: "Consultar Empresa",
		route: "/master-page/consultar-empresa",
		icon: "search",
		authorities: ["ROLE_REVENDEDOR", "ROLE_CONSULTOR_RELACIONAMENTO", "ROLE_ADMIN"],
	},
];